import { render } from "./CustomersGrid.vue?vue&type=template&id=06d33212"
import script from "./CustomersGrid.vue?vue&type=script&lang=js"
export * from "./CustomersGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__